// D-DRUGREF-3b: batch DrugReference values (category etc.) for Rx-rowed tables, resolved via the
// module-gated batch endpoint so core list queries stay untouched. Returns {} unless the
// drugreference module is enabled AND the caller actually has a drug_reference column configured.
import { useEffect, useState } from 'react'
import * as api from '../api/client'
import { useModules } from '../auth/ModulesContext'

export function useDrugRefValues(rowIds: string[], wanted: boolean): Record<string, api.RxDrugRefFields> {
  const { isDisabled } = useModules()
  const enabled = wanted && !isDisabled('drugreference')
  const [values, setValues] = useState<Record<string, api.RxDrugRefFields>>({})
  const idsKey = rowIds.join(',')
  useEffect(() => {
    if (!enabled || rowIds.length === 0) { setValues({}); return }
    let dead = false
    api.batchDrugRefForRx(rowIds).then(r => {
      if (dead) return
      // Normalize GUID casing: server key casing must never matter to renderer lookups.
      const norm: Record<string, api.RxDrugRefFields> = {}
      for (const [k, v] of Object.entries(r.values ?? {})) norm[k.toLowerCase()] = v
      setValues(norm)
    }).catch(() => {})
    return () => { dead = true }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [enabled, idsKey])
  return values
}
